// composables/Amortiguadores/useAmortiguadores.js - Funciones utilitarias y API calls
export const useAmortiguadores = () => {
  const config = useRuntimeConfig();

  const debug = {
    enabled: config.public.modo === 'DEV',
    log(...args) {
      if (this.enabled) console.log("[composables->Amortiguadores->useAmortiguadores.js]", ...args);
    },
    error(...args) {
      if (this.enabled) console.error(...args);
    },
  };

  //#region VALIDACIONES DE FORMULARIO
  const validateEmail = (email) => {
    const emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return email && emailRegex.test(email);
  };

  const validatePhoneNumber = (phone, country) => {
    const phoneRegex = /^[0-9]+$/;
    return (
      phone &&
      (country === '+56'
        ? phone.length === 9
        : phone.length >= 10 && phone.length <= 12) &&
      phoneRegex.test(phone)
    );
  };

  const validateString = (value) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ\s]+$/;
    if (!regex.test(value)) {
      return value.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ\s]+/g, "");
    }
    return value;
  };
  //#endregion

  //#region FUNCIONES UTILITARIAS DE FORMATO
  const formatearPrecio = (precio) => {
    if (typeof precio === "string") {
      precio = parseFloat(precio);
    }
    return new Intl.NumberFormat("es-CL").format(precio);
  };

  const formatearFecha = (fecha, hora) => {
    if (!fecha || !hora) return '';
    
    const fechaObj = new Date(fecha + 'T00:00:00');
    
    const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 
                  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    
    const diaSemana = dias[fechaObj.getDay()];
    const dia = fechaObj.getDate();
    const mes = meses[fechaObj.getMonth()];
    const año = fechaObj.getFullYear();
    
    return `${diaSemana}, ${dia} de ${mes} de ${año}. Hora ${hora}`;
  };

  const formatearModalidad = (modo) => {
    if (modo === 1) return 'Espera Vehículo';
    if (modo === 2) return 'Deja Vehículo';
    if (modo === 3) return 'Retira Vehículo';
    return 'Modo no válido';
  };

  const transformarModalidad = (valor_modo) => {
    if(valor_modo == 2) return 'DEJA';
    if(valor_modo == 3) return 'RETIRA';
    return 'ESPERA';
  };

  const transformarAPayloadPreorden = (AmortiguadoresPayload) => {
    debug.log('Payload original, AmortiguadoresPayload:', AmortiguadoresPayload);

    let retorno = {
      localSeleccionado: {
        alias: AmortiguadoresPayload.local,
        tipo: 'leon'
      },
      negocio: 'AMORTIGUADORES',
      sigla: 'AM',
      mode: AmortiguadoresPayload.modalidad,
      dateScheduleTime: AmortiguadoresPayload.fecha_hora,
      tempario: 30,
      isNowComing: 'NO',

      clientRut: AmortiguadoresPayload.rut,
      clientName: AmortiguadoresPayload.nombre,
      firstLastname: AmortiguadoresPayload.apellido_paterno,
      secondLastname: AmortiguadoresPayload.apellido_materno,
      phone: AmortiguadoresPayload.celular,
      email: AmortiguadoresPayload.email,

      carplate: AmortiguadoresPayload.patente !== 'XXXXXX' ? AmortiguadoresPayload.patente : null,
      vehicle: AmortiguadoresPayload.modo_busqueda === 'por_auto' ? {
        brand: AmortiguadoresPayload.marca,
        model: AmortiguadoresPayload.modelo,
        version: '',
        year: AmortiguadoresPayload.ano,
        image: null,
        brand_image: null
      } : null,
      patente_pais: 'CHILENO',

      thereIsAddressPickup: AmortiguadoresPayload.retiren_direccion !== '' ? 'SI' : 'NO',
      addressPickup: AmortiguadoresPayload.retiren_direccion || '',
      regionPickup: AmortiguadoresPayload.retiren_region || '',
      communePickup: AmortiguadoresPayload.retiren_comuna || '',
      observationPickup: AmortiguadoresPayload.retiren_comentario || '',
      depto_casa_pickup: null,

      thereReturnAddress: AmortiguadoresPayload.retiren_direccion_1 !== '' ? 'SI' : 'NO',
      returnAddress: AmortiguadoresPayload.retiren_direccion_1 || '',
      regionReturn: AmortiguadoresPayload.retiren_region_1 || '',
      communeReturn: AmortiguadoresPayload.retiren_comuna_1 || '',
      observationReturn: AmortiguadoresPayload.retiren_comentario_1 || '',
      depto_casa_return: null,

      products: [],
      services: [{
        type: 'SERVICIO-OBLIGATORIO',
        code: 'AG004',
        description: 'Agendamiento de Amortiguadores',
        unitPrice: 0,
        quantity: 1
      }],
      gifts: [],
      shipping: null,
      gifcardCode: '',
      dashboard_uuid: null
    };

    debug.log('Payload transformado, retorno:', retorno);
    return retorno;
  };
  //#endregion

  //#region VALIDACIONES DE DATOS
  const validarDatosVehiculo = (datos) => {
    const { marca, ano, modelo, local } = datos;
    return marca && ano && modelo && local;
  };

  const validarDatosPatente = (datos) => {
    const { patente, local } = datos;
    return patente && patente.length === 6 && local;
  };

  const validarBusqueda = (searchData) => {
    debug.log("searchData: ", searchData);
    const { local, modo_busqueda, patente, marca, ano, modelo} = searchData;

    if (!local) return false;

    if (modo_busqueda === "por_patente") {
      return patente && patente.length === 6;
    }

    if (modo_busqueda === "por_auto") {
      return !!(marca && ano && modelo);
    }

    return false;
  };

  const validarProductos = (producto_seleccionado) => {
    if (!producto_seleccionado || !producto_seleccionado.codigo_filtro) {
      debug.log('No hay codigo_filtro disponible');
      return false;
    }

    if (!producto_seleccionado || !producto_seleccionado.cadena_codigos) {
      debug.log('No hay cadena_codigos disponible');
      return false;
    }

    if (!producto_seleccionado || !producto_seleccionado.cadena_cantidad_envases) {
      debug.log('No hay cadena_cantidad_envases disponible');
      return false;
    }

    return true;
  };

  const validarDatosPersonales = (form) => {
    if (!form.email || !validateEmail(form.email)) return false;
    if (!form.nombre) return false;
    if (!form.apellido_paterno) return false;
    if (!form.apellido_materno) return false;
    if (!validatePhoneNumber(form.telefono, form.pais)) return false;
    
    return true;
  };
  //#endregion

  //#region API CALLS - BÚSQUEDA Y DATOS
  const cargarCalendario = async (data) => {
    const response = await $fetch("/api/amortiguadores/calendario", {
      method: "POST",
      query: { action: "calendario" },
      body: data,
    });

    debug.log("15-01-26, response: ",response);
    if (response.success === true) {
      return response.data;
    } else {
      throw new Error(response.message || "Error desconocido al cargar calendario");
    }
  };

  const cargarDetalleAgendamiento = async (data) => {
    const response = await $fetch("/api/amortiguadores/detalle", {
      method: "POST",
      query: { action: "getDetalleAgendamiento" },
      body: data,
    });

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message || "Error desconocido al cargar detalle de agendamiento");
    }
  };

  // Dentro de useAmortiguadores()

  const es_ok = (response) => {
    const status = (response?.status ?? "").toString().toLowerCase()
    if (status === "success") return true
    return response?.success === true
  }

  const extraer_lista = (response) => {
    const lista =
      response?.data?.Lista ??
      response?.data?.lista ??
      response?.Lista ??
      response?.lista ??
      response?.data

    return Array.isArray(lista) ? lista : null
  }

  const buscarMarcas = async () => {
    try {
      const response = await $fetch("/api/amortiguadores/vehiculos", {
        query: { action: "marcas" },
      })

      const lista = extraer_lista(response)
      if (es_ok(response) && lista) return lista

      debug.error("buscarMarcas respuesta inesperada:", response)
      return []
    } catch (e) {
      debug.error("buscarMarcas fallo $fetch:", e)
      return []
    }
  }

  const buscarAnosPorMarca = async (marca) => {
    try {
      const response = await $fetch("/api/amortiguadores/vehiculos", {
        query: { action: "anos", marca },
      })

      const lista = extraer_lista(response)
      if (es_ok(response) && lista) return lista

      debug.error("buscarAnosPorMarca respuesta inesperada:", { marca, response })
      return []
    } catch (e) {
      debug.error("buscarAnosPorMarca fallo $fetch:", e)
      return []
    }
  }

  const buscarModelosPorMarcaAno = async (marca, ano) => {
    try {
      const response = await $fetch("/api/amortiguadores/vehiculos", {
        query: { action: "modelos", ano, marca },
      })

      const lista = extraer_lista(response)
      if (es_ok(response) && lista) return lista

      debug.error("buscarModelosPorMarcaAno respuesta inesperada:", { marca, ano, response })
      return []
    } catch (e) {
      debug.error("buscarModelosPorMarcaAno fallo $fetch:", e)
      return []
    }
  }

  const buscarPorPatente = async (patente, local) => {
    const response = await $fetch("/api/amortiguadores/vehiculos", {
      query: {
        action: "patente",
        patente: patente,
        local: local,
      },
    });

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message || "Error al buscar por patente");
    }
  };
  //#endregion

  //#region AGENDAMIENTO - FLUJO SEGURO CON PREORDEN
  const agendar = async (payload) => {
    try {
      const { createPreOrderDataSecure, confirmPreOrderDataSecure } = useErpApi();
      
      debug.log('=== INICIANDO AGENDAMIENTO Amortiguadores SEGURO ===');

      // PASO 1: Transformar payload al formato de preorden
      const preordenPayload = transformarAPayloadPreorden(payload);

      // PASO 2: Crear preorden
      debug.log('Creando preorden...');
      const preordenResponse = await createPreOrderDataSecure(preordenPayload);
      debug.log('Respuesta crear preorden:', preordenResponse);

      if (!preordenResponse || !preordenResponse.uuid) {
        throw new Error('No se pudo crear la preorden');
      }

      // PASO 3: Confirmar preorden con método CASH
      debug.log('Confirmando preorden con UUID:', preordenResponse.uuid);
      const confirmResponse = await confirmPreOrderDataSecure({
        uuid: preordenResponse.uuid,
        payMode: 'CASH',
        urlSuccess: null,
        urlFailed: null,
        urlCanceled: null,
        urlTimeout: null
      });

      debug.log('Respuesta confirmar preorden:', confirmResponse);

      if (confirmResponse.metodo === 'CASH' && confirmResponse.resultado === 'Operación exitosa') {
        debug.log(' Agendamiento exitoso - UUID:', preordenResponse.uuid);
        return true;
      } else {
        throw new Error('Error al confirmar preorden');
      }

    } catch (error) {
      debug.error('❌ Error agendando:', error);
      return false;
    }
  };
  //#endregion

  //#region RETORNO
  return {
    // Validaciones de formulario
    validateEmail,
    validateString,
    validarDatosPersonales,

    // Formateo
    formatearPrecio,
    formatearFecha,
    formatearModalidad,
    transformarModalidad,

    // Validaciones de datos
    validarDatosVehiculo,
    validarDatosPatente,
    validarBusqueda,
    validarProductos,

    // API calls
    cargarDetalleAgendamiento,
    cargarCalendario,
    buscarMarcas,
    buscarAnosPorMarca,
    buscarModelosPorMarcaAno,
    buscarPorPatente,
    
    // Agendamiento
    agendar,
    transformarAPayloadPreorden,
  };
  //#endregion
};